import script from "./ScraperManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ScraperManagement.vue?vue&type=script&setup=true&lang=js"

import "./ScraperManagement.vue?vue&type=style&index=0&id=66dbddca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66dbddca"]])

export default __exports__